import React from 'react';
import { SparklesIcon } from 'lucide-react';
export function WhatChanges() {
  const scrollToCompra = () => {
    document.getElementById('compra')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const changes = ['Entendés nuevas posibilidades laborales', 'Sabés cómo posicionarte profesionalmente', 'Tenés herramientas para conseguir entrevistas', 'Dejás de sentirte perdido/a', 'Empezás a construir una nueva etapa'];
  return <section className="py-12 md:py-20 bg-white" data-id="element-148">
      <div className="max-w-4xl mx-auto px-4" data-id="element-149">
        <h2 className="text-3xl md:text-4xl font-bold text-center text-gray-900 mb-12" data-id="element-150">
          LO QUE PUEDE CAMBIAR
        </h2>
        <div className="grid md:grid-cols-2 gap-6" data-id="element-151">
          {changes.map((change, index) => <div key={index} onClick={scrollToCompra} className="flex items-start gap-3 p-6 bg-slate-50 rounded-lg hover:shadow-md transition-all cursor-pointer border border-gray-100" data-id="element-152">
              <SparklesIcon className="w-6 h-6 text-amber-500 flex-shrink-0 mt-0.5" data-id="element-153" />
              <p className="text-gray-800 font-medium" data-id="element-154">{change}</p>
            </div>)}
        </div>
      </div>
    </section>;
}